import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var menuItem = function menuItem() {
  Alpine.data('menuItem', function () {
    var hasSubMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return {
      hasSubMenu: hasSubMenu,
      subMenuIsOpen: false,
      init: function init() {
        this.hasSubMenu = hasSubMenu;
      },
      toggleSubMenu: function toggleSubMenu() {
        if (!breakpoint.isDesktopXl) {
          this.$event.preventDefault();
        }
        this.subMenuIsOpen = !this.subMenuIsOpen;
      },
      handleClickSubMenuButton: function handleClickSubMenuButton() {
        var hasHref = this.$el.getAttribute('href') !== null;
        var isDropdownButton = this.$el.getAttribute('x-ref') === 'subMenuButton';
        var notLinkAndHasSubMenu = this.hasSubMenu && (!hasHref || !breakpoint.isDesktopXl);
        if (notLinkAndHasSubMenu || isDropdownButton) {
          this.toggleSubMenu();
        }
      },
      bindToggleSubMenu: {
        // eslint-disable-next-line func-names
        '@click': function click() {
          this.handleClickSubMenuButton();
        }
      },
      subMenu: {
        // eslint-disable-next-line func-names
        'x-show': function xShow() {
          return this.subMenuIsOpen;
        },
        // eslint-disable-next-line func-names
        'x-transition:enter-start': function xTransitionEnterStart() {
          return 'opacity-0 bg-grey-100';
        },
        // eslint-disable-next-line func-names
        'x-transition:enter-end': function xTransitionEnterEnd() {
          return 'opacity-100';
        },
        // eslint-disable-next-line func-names
        'x-transition:leave-start': function xTransitionLeaveStart() {
          return 'opacity-100 bg-grey-100';
        },
        // eslint-disable-next-line func-names
        'x-transition:leave-end': function xTransitionLeaveEnd() {
          return 'opacity-0';
        }
      },
      bindMenuItemPrimary: {
        // eslint-disable-next-line func-names
        '@click': function click() {
          // Ignore logic for menu mobile view.
          if (breakpoint.isDesktopXl) {
            this.subMenuIsOpen = this.subMenuIsOpen && breakpoint.isDesktopXl;
          }
        },
        // eslint-disable-next-line func-names
        '@click.away': function clickAway() {
          if (this.subMenuIsOpen && breakpoint.isDesktopXl) {
            this.subMenuIsOpen = false;
          }
        }
      },
      bindMenuItemPrimaryLink: {
        // eslint-disable-next-line func-names
        '@click': function click() {
          //this.handleClickSubMenuButton();
          // Ignore logic for menu mobile view.
          if (breakpoint.isDesktopXl) {
            this.subMenuIsOpen = !this.subMenuIsOpen && breakpoint.isDesktopXl;
          }
        },
        // eslint-disable-next-line func-names
        '@keydown.escape': function keydownEscape() {
          this.$refs.subMenuButton.focus();
        },
        // eslint-disable-next-line func-names
        '@keydown.escape.window': function keydownEscapeWindow() {
          this.subMenuIsOpen = false;
        }
      }
    };
  });
};